export const heroData = {
  title: "惠美梨",
  subtitle: "品质优选，甜蜜直达你的餐桌",
  description: "精选优质梨果，皮薄汁多、清甜爽口，产地直供保障新鲜品质。无论是日常鲜食还是礼品馈赠，惠美梨都是您的首选。",
  ctaText: "探索品种",
  ctaLink: "/category",
  secondaryCtaText: "了解更多",
  secondaryCtaLink: "/about",
};

export const productCategories = [
  {
    id: "cuiguan",
    name: "翠冠梨",
    tagline: "盛夏第一口清甜",
    description: "翠冠梨是惠美梨的明星品种，果实呈圆形或长圆形，果皮黄绿色，果肉洁白细腻，汁多味甜，石细胞极少。每年7月中下旬成熟，是夏季消暑解渴的绝佳选择。",
    features: ["皮薄汁多", "细腻无渣", "清甜爽口", "夏季专属"],
    imageSeq: "cuiguan-pear",
    detail: "翠冠梨产自惠美梨核心种植基地，地处北纬30°黄金水果种植带。这里气候温和、光照充足、昼夜温差大，赋予了翠冠梨独特的清甜口感。每一颗翠冠梨都经过严格筛选，果形端正、色泽均匀，单果重量在250g以上，含糖量达12%以上。从枝头到餐桌，全程冷链保鲜，确保每一口都是最新鲜的滋味。翠冠梨不仅适合直接鲜食，还可制作冰糖雪梨、梨膏等传统美食，润肺止咳，老少皆宜。",
    specifications: [
      { label: "单果重量", value: "250g-400g" },
      { label: "含糖量", value: "12%-15%" },
      { label: "成熟期", value: "7月中下旬" },
      { label: "保质期", value: "冷藏15天" },
    ],
  },
  {
    id: "huanghua",
    name: "黄花梨",
    tagline: "金黄饱满，香甜浓郁",
    description: "黄花梨果实硕大，果皮金黄色，外观极为诱人。果肉酥脆爽口，甜度高、香气浓郁，是梨中佳品。黄花梨成熟期在8月下旬至9月上旬，正值金秋时节，是中秋送礼的上佳之选。",
    features: ["金黄外观", "酥脆口感", "香甜浓郁", "送礼首选"],
    imageSeq: "huanghua-pear",
    detail: "黄花梨在惠美梨自有果园中精心培育，采用生态种植方式，全程不使用化学催熟剂。果园采用智能化水肥管理系统，精准控制每一棵梨树的营养供给。成熟的黄花梨果皮金黄透亮，仿佛披上了秋日的暖阳。切开的瞬间，清甜的梨香扑鼻而来，汁水丰盈欲滴。黄花梨特别适合制作精美礼盒，惠美梨提供多种规格的礼盒包装，从6枚装到12枚装，满足不同送礼场景的需求。",
    specifications: [
      { label: "单果重量", value: "300g-500g" },
      { label: "含糖量", value: "13%-16%" },
      { label: "成熟期", value: "8月下旬-9月上旬" },
      { label: "保质期", value: "冷藏20天" },
    ],
  },
  {
    id: "fengshui",
    name: "丰水梨",
    tagline: "汁水丰盈，润泽心田",
    description: "丰水梨果形端正，果皮棕褐色，果肉晶莹剔透、口感极嫩。正如其名，丰水梨的汁水含量在梨果品种中首屈一指，一口咬下，清甜的梨汁瞬间充盈口腔，令人回味无穷。",
    features: ["汁多如泉", "肉质细嫩", "甜而不腻", "营养丰富"],
    imageSeq: "fengshui-pear",
    detail: "惠美梨的丰水梨种植基地坐落于海拔800米以上的山地果园，充沛的降水和显著的昼夜温差造就了丰水梨独一无二的多汁特性。果园坚持有机种植标准，以农家肥为主、生物防治为辅，确保每一颗丰水梨都达到绿色食品标准。丰水梨富含多种维生素和矿物质，其中维生素C含量尤为突出，每100g果肉含维生素C约4mg，是日常补充维C的天然佳品。",
    specifications: [
      { label: "单果重量", value: "280g-450g" },
      { label: "含糖量", value: "11%-14%" },
      { label: "成熟期", value: "9月上旬-9月下旬" },
      { label: "保质期", value: "冷藏18天" },
    ],
  },
  {
    id: "xuehua",
    name: "雪花梨",
    tagline: "洁白如雪，清雅甘甜",
    description: "雪花梨因肉质洁白如雪而得名，果实呈卵圆形，果皮绿黄色。雪花梨口感清雅甘甜，不腻不燥，且耐储存，是惠美梨冬季主推的明星品种。古人云“一颗雪花梨，胜过百药方”，足见其养生价值。",
    features: ["肉质洁白", "清雅甘甜", "耐储存", "养生佳品"],
    imageSeq: "xuehua-pear",
    detail: "雪花梨是惠美梨传统优势品种，种植历史超过30年。果园位于天然水源保护区内，灌溉用水来自山泉溪流，水质纯净无污染。雪花梨的采摘时间在10月上旬，此时早晚温差已达15℃以上，极有利于糖分积累。雪花梨最大的特点是耐储存，在专业冷库中可保鲜至次年春季。惠美梨采用先进的气调贮藏技术，精准控制库内温度、湿度和气体成分，让雪花梨在长达半年的储存期内依然保持新鲜如初的口感和营养。",
    specifications: [
      { label: "单果重量", value: "200g-350g" },
      { label: "含糖量", value: "10%-13%" },
      { label: "成熟期", value: "10月上旬" },
      { label: "保质期", value: "冷藏180天" },
    ],
  },
];

export const brandFeatures = [
  {
    icon: "ri-seedling-line",
    title: "产地直供",
    description: "自有果园基地，从枝头到餐桌，全程品质把控，减少中间环节，确保新鲜直达。",
  },
  {
    icon: "ri-shield-check-line",
    title: "品质严选",
    description: "每一颗惠美梨都经过人工严格筛选，果形、色泽、甜度、重量四项达标方可出库。",
  },
  {
    icon: "ri-truck-line",
    title: "冷链配送",
    description: "全程冷链运输，精准温控保鲜，确保惠美梨以最佳状态送达您的手中。",
  },
  {
    icon: "ri-leaf-line",
    title: "生态种植",
    description: "坚持绿色种植标准，以有机肥为主、生物防治为辅，让每一口都安心健康。",
  },
  {
    icon: "ri-gift-line",
    title: "精美礼盒",
    description: "多种规格礼盒包装可选，设计典雅大方，是节日送礼、商务馈赠的上佳之选。",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "贴心服务",
    description: "专业客服团队随时为您解答疑问，售后无忧，让您的购物体验更加舒心。",
  },
];

export const faqData = [
  {
    question: "惠美梨的产地在哪里？",
    answer: "惠美梨的种植基地位于中国优质梨果核心产区，地处北纬30°黄金水果种植带，拥有得天独厚的自然条件——气候温和、光照充足、昼夜温差大、水源纯净，为梨果生长提供了最佳环境。",
  },
  {
    question: "惠美梨有哪些品种？各有什么特点？",
    answer: "惠美梨目前主推四个品种：翠冠梨（7月成熟，皮薄汁多、清甜爽口，适合夏季消暑）、黄花梨（8-9月成熟，金黄饱满、香甜浓郁，适合中秋送礼）、丰水梨（9月成熟，汁水丰盈、口感极嫩）、雪花梨（10月成熟，洁白如雪、清雅甘甜，耐储存，适合冬季养生）。",
  },
  {
    question: "如何购买惠美梨？",
    answer: "您可以通过以下方式购买惠美梨：1）访问我们的微信小程序商城在线下单；2）拨打客服热线 400-XXX-XXXX 进行电话订购；3）前往惠美梨线下合作门店选购。我们提供全国范围的冷链配送服务。",
  },
  {
    question: "惠美梨的保质期是多久？如何保存？",
    answer: "惠美梨建议在收到后冷藏保存（0-4℃），不同品种的保质期略有差异：翠冠梨冷藏约15天，黄花梨冷藏约20天，丰水梨冷藏约18天，雪花梨冷藏可达180天。建议尽早食用以获得最佳口感。",
  },
  {
    question: "惠美梨礼盒有哪些规格？适合什么场景？",
    answer: "惠美梨提供多种礼盒规格：6枚精品装（适合家庭尝鲜）、8枚尊享装（适合走亲访友）、12枚典藏装（适合商务馈赠）。礼盒包装精美典雅，内附产品介绍卡片和保鲜指南，是中秋、春节等节日送礼的品质之选。",
  },
  {
    question: "惠美梨是否支持企业团购或定制？",
    answer: "惠美梨全面支持企业团购和个性化定制服务。我们可为您的企业定制专属礼盒包装，印制企业LOGO和祝福语，满足年会礼品、客户答谢、员工福利等多种场景需求。具体请联系客服热线了解更多团购优惠。",
  },
];

export const newsData = [
  {
    id: "news-1",
    title: "惠美梨2026年翠冠梨新鲜上市，首批预售火爆开启",
    excerpt: "盛夏七月，惠美梨翠冠梨迎来丰收季。得益于今年充沛的雨水和充足的日照，本季翠冠梨品质再创新高，单果均重突破300g，含糖量达14%以上。",
    date: "2026-07-15",
    category: "产品动态",
    imageSeq: "news-cuiguan-2026",
  },
  {
    id: "news-2",
    title: "惠美梨荣获2026年中国优质农产品金奖",
    excerpt: "在刚刚落幕的2026年中国优质农产品博览会上，惠美梨黄花梨品种凭借卓越品质脱颖而出，荣获金奖殊荣，这是对惠美梨坚持品质路线的最好肯定。",
    date: "2026-06-28",
    category: "品牌荣誉",
    imageSeq: "news-award-2026",
  },
  {
    id: "news-3",
    title: "惠美梨智能果园升级完成，科技赋能品质再提升",
    excerpt: "惠美梨投资建设的智慧农业系统全面升级完成，引入AI图像识别分选、无人机巡检、物联网环境监测等先进技术，实现从种植到分选的全链路智能化管理。",
    date: "2026-05-20",
    category: "企业动态",
    imageSeq: "news-tech-2026",
  },
];

export const statsData = [
  { value: "30+", label: "年种植历史" },
  { value: "5000+", label: "亩自有果园" },
  { value: "100万+", label: "年销梨果(斤)" },
  { value: "98%", label: "客户好评率" },
];

export const testimonialsData = [
  {
    name: "张女士",
    role: "老顾客 · 北京",
    content: "每年夏天都等惠美梨的翠冠梨上市，皮薄汁多、清甜爽口，全家人都爱吃。今年还订了礼盒送亲戚，包装很精美，送礼倍有面子！",
    rating: 5,
  },
  {
    name: "李先生",
    role: "企业采购 · 上海",
    content: "公司中秋福利选了惠美梨黄花梨礼盒，员工反馈非常好。梨果个头均匀、口感香甜，礼盒设计也很有档次，明年还会继续采购。",
    rating: 5,
  },
  {
    name: "王女士",
    role: "美食博主 · 广州",
    content: "做美食评测这么多年，惠美梨的丰水梨是我吃过汁水最足的梨！切开瞬间汁水四溢，口感如丝绸般嫩滑，强烈推荐给所有爱吃梨的朋友。",
    rating: 5,
  },
];